import React from 'react';
import Slider from 'react-slick';
import { WithTranslation } from 'next-i18next';

import H3 from 'components/typo/Heading/H3';
import PersonReferenceBadge from 'components/PersonReferenceBadge';
import { withTranslation } from 'lib/i18n';

import SIDBBox from '../SIDBBox';
import zasilkovnaPic from '../images/reference-kijonkova.jpg';
import zasilkovnaLogo from '../images/logo-zasilkovna.png';
import snowbitchPic from '../images/reference-cafourek.jpg';
import snowbitchLogo from '../images/logo-snowbitch.png';
import boardstarPic from '../images/reference-snizek.jpg';
import boardstarLogo from '../images/logo-boardstar.png';

import { NextArrow, PrevArrow } from './Arrows';
import Slide from './styled/Slide';

const settings = {
  adaptiveHeight: false,
  autoplay: true,
  dots: false,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
};

const BusinessCarousel: React.FC = props => (
  <Slider {...settings}>{props.children}</Slider>
);

const CarouselInstance: React.FC<WithTranslation> = ({ t }) => (
  <BusinessCarousel>
    <Slide>
      <SIDBBox>
        <H3>
          <q>{t('business.index.about.references.zasilkovna.text')}</q>
        </H3>
        <PersonReferenceBadge
          pic={zasilkovnaPic}
          logo={zasilkovnaLogo}
          name={t('business.index.about.references.zasilkovna.name')}
          job={t('business.index.about.references.zasilkovna.job')}
        />
      </SIDBBox>
    </Slide>
    <Slide>
      <SIDBBox>
        <H3>
          <q>{t('business.index.about.references.snowbitch.text')}</q>
        </H3>
        <PersonReferenceBadge
          pic={snowbitchPic}
          logo={snowbitchLogo}
          name={t('business.index.about.references.snowbitch.name')}
          job={t('business.index.about.references.snowbitch.job')}
        />
      </SIDBBox>
    </Slide>
    <Slide>
      <SIDBBox>
        <H3>
          <q>{t('business.index.about.references.boardstar.text')}</q>
        </H3>
        <PersonReferenceBadge
          pic={boardstarPic}
          logo={boardstarLogo}
          name={t('business.index.about.references.boardstar.name')}
          job={t('business.index.about.references.boardstar.job')}
        />
      </SIDBBox>
    </Slide>
  </BusinessCarousel>
);

export default withTranslation('pages')(CarouselInstance);
